export default __webpack_public_path__ + "static/media/DIVA-01.3bcc2edc.jpg";